import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export const Lightbox = ({ open, images, index, onClose, onPrev, onNext }) => (
  <AnimatePresence>
    {open && images && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center"
        onClick={onClose}
      >
        <button
          onClick={onClose}
          className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors z-10"
          aria-label="Close lightbox"
        >
          <X size={32} />
        </button>
        <button
          onClick={(e) => { e.stopPropagation(); onPrev(); }}
          className="absolute left-6 text-white/70 hover:text-white transition-colors z-10"
          aria-label="Previous image"
        >
          <ChevronLeft size={48} />
        </button>
        <button
          onClick={(e) => { e.stopPropagation(); onNext(); }}
          className="absolute right-6 text-white/70 hover:text-white transition-colors z-10"
          aria-label="Next image"
        >
          <ChevronRight size={48} />
        </button>
        <motion.img
          key={index}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          src={images[index]}
          alt={`Gallery image ${index + 1}`}
          className="max-w-[90vw] max-h-[85vh] object-contain"
          onClick={(e) => e.stopPropagation()}
        />
        <div className="absolute bottom-6 text-white/50 text-sm">
          {index + 1} / {images.length}
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);
